export const districtListCHL = [
    { value: 'COYHAIQUE', label: 'COYHAIQUE' },
    { value: 'LAGO VERDE', label: 'LAGO VERDE' },
    { value: 'AYSEN', label: 'AYSEN' },
    { value: 'CISNES', label: 'CISNES' },
    { value: 'GUAITECAS', label: 'GUAITECAS' },
    { value: 'COCHRANE', label: 'COCHRANE' },
    { value: 'O HIGGINS', label: 'O HIGGINS' },
    { value: 'TORTEL', label: 'TORTEL' },
    { value: 'CHILE CHICO', label: 'CHILE CHICO' },
    { value: 'RIO IBANEZ', label: 'RIO IBANEZ' },
    { value: 'ANTOFAGASTA', label: 'ANTOFAGASTA' },
    { value: 'MEJILLONES', label: 'MEJILLONES' },
    { value: 'SIERRA GORDA', label: 'SIERRA GORDA' },
    { value: 'TALTAL', label: 'TALTAL' },
    { value: 'CALAMA', label: 'CALAMA' },
    { value: 'OLLAGUE', label: 'OLLAGUE' },
    { value: 'SAN PEDRO DE ATACAMA', label: 'SAN PEDRO DE ATACAMA' },
    { value: 'TOCOPILLA', label: 'TOCOPILLA' },
    { value: 'MARIA ELENA', label: 'MARIA ELENA' },
    { value: 'ARICA', label: 'ARICA' },
    { value: 'CAMARONES', label: 'CAMARONES' },
    { value: 'PUTRE', label: 'PUTRE' },
    { value: 'GENERAL LAGOS', label: 'GENERAL LAGOS' },
    { value: 'TEMUCO', label: 'TEMUCO' },
    { value: 'CARAHUE', label: 'CARAHUE' },
    { value: 'CHOLCHOL', label: 'CHOLCHOL' },
    { value: 'CUARARREHUE', label: 'CUARARREHUE' },
    { value: 'FREIRE', label: 'FREIRE' },
    { value: 'GALVARINO', label: 'GALVARINO' },
    { value: 'GORBEA', label: 'GORBEA' },
    { value: 'LAUTARO', label: 'LAUTARO' },
    { value: 'LONCOCHE', label: 'LONCOCHE' },
    { value: 'MELIPEUCO', label: 'MELIPEUCO' },
    { value: 'NUEVA IMPERIAL', label: 'NUEVA IMPERIAL' },
    { value: 'PADRE LAS CASAS', label: 'PADRE LAS CASAS' },
    { value: 'PERQUENCO', label: 'PERQUENCO' },
    { value: 'PITRUFQUEN', label: 'PITRUFQUEN' },
    { value: 'PUCON', label: 'PUCON' },
    { value: 'SAAVEDRA', label: 'SAAVEDRA' },
    { value: 'TEODORO SCHMIDT', label: 'TEODORO SCHMIDT' },
    { value: 'VILLARRICA', label: 'VILLARRICA' },
    { value: 'VILCUN', label: 'VILCUN' },
    { value: 'TOLTEN', label: 'TOLTEN' },
    { value: 'CUNCO', label: 'CUNCO' },
    { value: 'ANGOL', label: 'ANGOL' },
    { value: 'COLLIPULLI', label: 'COLLIPULLI' },
    { value: 'CURACAUTIN', label: 'CURACAUTIN' },
    { value: 'ERCILLA', label: 'ERCILLA' },
    { value: 'LONQUIMAY', label: 'LONQUIMAY' },
    { value: 'LOS SAUCES', label: 'LOS SAUCES' },
    { value: 'LUMACO', label: 'LUMACO' },
    { value: 'PUREN', label: 'PUREN' },
    { value: 'RENAICO', label: 'RENAICO' },
    { value: 'TRAIGUEN', label: 'TRAIGUEN' },
    { value: 'VICTORIA', label: 'VICTORIA' },
    { value: 'COPIAPO', label: 'COPIAPO' },
    { value: 'CALDERA', label: 'CALDERA' },
    { value: 'TIERRA AMARILLA', label: 'TIERRA AMARILLA' },
    { value: 'CHANARAL', label: 'CHANARAL' },
    { value: 'DIEGO DE ALMAGRO', label: 'DIEGO DE ALMAGRO' },
    { value: 'VALLENAR', label: 'VALLENAR' },
    { value: 'ALTO DEL CARMEN', label: 'ALTO DEL CARMEN' },
    { value: 'FREIRINA', label: 'FREIRINA' },
    { value: 'HUASCO', label: 'HUASCO' },
    { value: 'TOME', label: 'TOME' },
    { value: 'TALCAHUANO', label: 'TALCAHUANO' },
    { value: 'SANTA JUANA', label: 'SANTA JUANA' },
    { value: 'SAN PEDRO DE LA PAZ', label: 'SAN PEDRO DE LA PAZ' },
    { value: 'PENCO', label: 'PENCO' },
    { value: 'LOTA', label: 'LOTA' },
    { value: 'HUALQUI', label: 'HUALQUI' },
    { value: 'HUALPEN', label: 'HUALPEN' },
    { value: 'FLORIDA', label: 'FLORIDA' },
    { value: 'CORONEL', label: 'CORONEL' },
    { value: 'CONCEPCION', label: 'CONCEPCION' },
    { value: 'CHIGUAYANTE', label: 'CHIGUAYANTE' },
    { value: 'TIRUA', label: 'TIRUA' },
    { value: 'LOS ALAMOS', label: 'LOS ALAMOS' },
    { value: 'LEBU', label: 'LEBU' },
    { value: 'CURANILAHUE', label: 'CURANILAHUE' },
    { value: 'CONTULMO', label: 'CONTULMO' },
    { value: 'CANETE', label: 'CANETE' },
    { value: 'ARAUCO', label: 'ARAUCO' },
    { value: 'YUMBEL', label: 'YUMBEL' },
    { value: 'TUCAPEL', label: 'TUCAPEL' },
    { value: 'SANTA BARBARA', label: 'SANTA BARBARA' },
    { value: 'SAN ROSENDO', label: 'SAN ROSENDO' },
    { value: 'QUILLECO', label: 'QUILLECO' },
    { value: 'QUILACO', label: 'QUILACO' },
    { value: 'NEGRETE', label: 'NEGRETE' },
    { value: 'NACIMIENTO', label: 'NACIMIENTO' },
    { value: 'MAULCHEN', label: 'MAULCHEN' },
    { value: 'LOS ANGELES', label: 'LOS ANGELES' },
    { value: 'LAJA', label: 'LAJA' },
    { value: 'CABRERO', label: 'CABRERO' },
    { value: 'ANTUCO', label: 'ANTUCO' },
    { value: 'ALTO BIOBIO', label: 'ALTO BIOBIO' },
    { value: 'CHILLAN', label: 'CHILLAN' },
    { value: 'BULNES', label: 'BULNES' },
    { value: 'COBQUECURA', label: 'COBQUECURA' },
    { value: 'COELEMU', label: 'COELEMU' },
    { value: 'COIHUECO', label: 'COIHUECO' },
    { value: 'CHILLAN VIEJO', label: 'CHILLAN VIEJO' },
    { value: 'EL CARMEN', label: 'EL CARMEN' },
    { value: 'NINHUE', label: 'NINHUE' },
    { value: 'NIQUEN', label: 'NIQUEN' },
    { value: 'PEMUCO', label: 'PEMUCO' },
    { value: 'PINTO', label: 'PINTO' },
    { value: 'PORTEZUELO', label: 'PORTEZUELO' },
    { value: 'QUILLON', label: 'QUILLON' },
    { value: 'QUIRIHUE', label: 'QUIRIHUE' },
    { value: 'RANQUIL', label: 'RANQUIL' },
    { value: 'SAN CARLOS', label: 'SAN CARLOS' },
    { value: 'SAN FABIAN DE ALICO', label: 'SAN FABIAN DE ALICO' },
    { value: 'SAN IGNACIO', label: 'SAN IGNACIO' },
    { value: 'SAN NICOLAS', label: 'SAN NICOLAS' },
    { value: 'TREHUACO', label: 'TREHUACO' },
    { value: 'YUNGAY', label: 'YUNGAY' },
    { value: 'LA SERENA', label: 'LA SERENA' },
    { value: 'COQUIMBO', label: 'COQUIMBO' },
    { value: 'ANDACOLLO', label: 'ANDACOLLO' },
    { value: 'LA HIGUERA', label: 'LA HIGUERA' },
    { value: 'PAIHUANO', label: 'PAIHUANO' },
    { value: 'VICUNA', label: 'VICUNA' },
    { value: 'ILLAPEL', label: 'ILLAPEL' },
    { value: 'CANELA', label: 'CANELA' },
    { value: 'LOS VILOS', label: 'LOS VILOS' },
    { value: 'SALAMANCA', label: 'SALAMANCA' },
    { value: 'OVALLE', label: 'OVALLE' },
    { value: 'COMBARBALA', label: 'COMBARBALA' },
    { value: 'MONTE PATRIA', label: 'MONTE PATRIA' },
    { value: 'PUNITAQUI', label: 'PUNITAQUI' },
    { value: 'RIO HURTADO', label: 'RIO HURTADO' },
    { value: 'RANCAGUA', label: 'RANCAGUA' },
    { value: 'CODEGUA', label: 'CODEGUA' },
    { value: 'COINCO', label: 'COINCO' },
    { value: 'COLTAUCO', label: 'COLTAUCO' },
    { value: 'CONIHUE', label: 'CONIHUE' },
    { value: 'GRANEROS', label: 'GRANEROS' },
    { value: 'LAS CABRAS', label: 'LAS CABRAS' },
    { value: 'MACHALI', label: 'MACHALI' },
    { value: 'MALLOA', label: 'MALLOA' },
    { value: 'MOSTAZAL', label: 'MOSTAZAL' },
    { value: 'OLIVAR', label: 'OLIVAR' },
    { value: 'PEUMO', label: 'PEUMO' },
    { value: 'PICHIDEGUA', label: 'PICHIDEGUA' },
    { value: 'QUINTA DE TILCOCO', label: 'QUINTA DE TILCOCO' },
    { value: 'RENGO', label: 'RENGO' },
    { value: 'REQUINOA', label: 'REQUINOA' },
    { value: 'SAN VICENTE', label: 'SAN VICENTE' },
    { value: 'PICHILEMU', label: 'PICHILEMU' },
    { value: 'LA ESTRELLA', label: 'LA ESTRELLA' },
    { value: 'LITUECHE', label: 'LITUECHE' },
    { value: 'MARCHIHUE', label: 'MARCHIHUE' },
    { value: 'NAVIDAD', label: 'NAVIDAD' },
    { value: 'PAREDONES', label: 'PAREDONES' },
    { value: 'SAN FERNANDO', label: 'SAN FERNANDO' },
    { value: 'CHEPICA', label: 'CHEPICA' },
    { value: 'CHIMBARONGO', label: 'CHIMBARONGO' },
    { value: 'LOLOL', label: 'LOLOL' },
    { value: 'NANCAGUA', label: 'NANCAGUA' },
    { value: 'PALMILLA', label: 'PALMILLA' },
    { value: 'PERALILLO', label: 'PERALILLO' },
    { value: 'PLACILLA', label: 'PLACILLA' },
    { value: 'PUMANQUE', label: 'PUMANQUE' },
    { value: 'SANTA CRUZ', label: 'SANTA CRUZ' },
    { value: 'PUERTO MONTT', label: 'PUERTO MONTT' },
    { value: 'CALBUCO', label: 'CALBUCO' },
    { value: 'COCHAMO', label: 'COCHAMO' },
    { value: 'FRESIA', label: 'FRESIA' },
    { value: 'FRUTILLAR', label: 'FRUTILLAR' },
    { value: 'LOS MUERMOS', label: 'LOS MUERMOS' },
    { value: 'LLANQUIHUE', label: 'LLANQUIHUE' },
    { value: 'MAULLIN', label: 'MAULLIN' },
    { value: 'PUERTO VARAS', label: 'PUERTO VARAS' },
    { value: 'CASTRO', label: 'CASTRO' },
    { value: 'ANCUD', label: 'ANCUD' },
    { value: 'CHONCHI', label: 'CHONCHI' },
    { value: 'CURACO DE VELEZ', label: 'CURACO DE VELEZ' },
    { value: 'DALCAHUE', label: 'DALCAHUE' },
    { value: 'PUQUELDON', label: 'PUQUELDON' },
    { value: 'QUEILEN', label: 'QUEILEN' },
    { value: 'QUELLON', label: 'QUELLON' },
    { value: 'QUEMCHI', label: 'QUEMCHI' },
    { value: 'QUINCHAO', label: 'QUINCHAO' },
    { value: 'OSORNO', label: 'OSORNO' },
    { value: 'PUERTO OCTAY', label: 'PUERTO OCTAY' },
    { value: 'PURRANQUE', label: 'PURRANQUE' },
    { value: 'PUYEHUE', label: 'PUYEHUE' },
    { value: 'RIO NEGRO', label: 'RIO NEGRO' },
    { value: 'SAN JUAN DE LA COSTA', label: 'SAN JUAN DE LA COSTA' },
    { value: 'SAN PABLO', label: 'SAN PABLO' },
    { value: 'CHAITEN', label: 'CHAITEN' },
    { value: 'FUTALEUFU', label: 'FUTALEUFU' },
    { value: 'HUALAIHUE', label: 'HUALAIHUE' },
    { value: 'PALENA', label: 'PALENA' },
    { value: 'VALDIVIA', label: 'VALDIVIA' },
    { value: 'CORRAL', label: 'CORRAL' },
    { value: 'LANCO', label: 'LANCO' },
    { value: 'LOS LAGOS', label: 'LOS LAGOS' },
    { value: 'MAFIL', label: 'MAFIL' },
    { value: 'SAN JOSE DE MARIQUINA', label: 'SAN JOSE DE MARIQUINA' },
    { value: 'PAILLACO', label: 'PAILLACO' },
    { value: 'PANGUIPULLI', label: 'PANGUIPULLI' },
    { value: 'LA UNION', label: 'LA UNION' },
    { value: 'FUTRONO', label: 'FUTRONO' },
    { value: 'LAGO RANCO', label: 'LAGO RANCO' },
    { value: 'RIO BUENO', label: 'RIO BUENO' },
    { value: 'PUNTA ARENAS', label: 'PUNTA ARENAS' },
    { value: 'LAGUNA BLANCA', label: 'LAGUNA BLANCA' },
    { value: 'RIO VERDE', label: 'RIO VERDE' },
    { value: 'SAN GREGORIO', label: 'SAN GREGORIO' },
    { value: 'CABO DE HORNOS', label: 'CABO DE HORNOS' },
    { value: 'ANTARTICA', label: 'ANTARTICA' },
    { value: 'PORVENIR', label: 'PORVENIR' },
    { value: 'PRIMAVERA', label: 'PRIMAVERA' },
    { value: 'TIMAUKEL', label: 'TIMAUKEL' },
    { value: 'PUERTO NATALES', label: 'PUERTO NATALES' },
    { value: 'TORRES DEL PAINE', label: 'TORRES DEL PAINE' },
    { value: 'TALCAHUANO', label: 'TALCAHUANO' },
    { value: 'CONSTITUCION', label: 'CONSTITUCION' },
    { value: 'CUREPTO', label: 'CUREPTO' },
    { value: 'EMPEDRADO', label: 'EMPEDRADO' },
    { value: 'MAULE', label: 'MAULE' },
    { value: 'PELARCO', label: 'PELARCO' },
    { value: 'PENCAHUE', label: 'PENCAHUE' },
    { value: 'RIO CLARO', label: 'RIO CLARO' },
    { value: 'SAN CLEMENTE', label: 'SAN CLEMENTE' },
    { value: 'SAN RAFAEL', label: 'SAN RAFAEL' },
    { value: 'CAUQUENES', label: 'CAUQUENES' },
    { value: 'CHANCO', label: 'CHANCO' },
    { value: 'PELLUHUE', label: 'PELLUHUE' },
    { value: 'CURICO', label: 'CURICO' },
    { value: 'HUALANE', label: 'HUALANE' },
    { value: 'LICANTEN', label: 'LICANTEN' },
    { value: 'MOLINA', label: 'MOLINA' },
    { value: 'RAUCO', label: 'RAUCO' },
    { value: 'ROMERAL', label: 'ROMERAL' },
    { value: 'SAGRADA FAMILIA', label: 'SAGRADA FAMILIA' },
    { value: 'TENO', label: 'TENO' },
    { value: 'VICHUQUEN', label: 'VICHUQUEN' },
    { value: 'LINARES', label: 'LINARES' },
    { value: 'COLBUN', label: 'COLBUN' },
    { value: 'LONGAVI', label: 'LONGAVI' },
    { value: 'PARRAL', label: 'PARRAL' },
    { value: 'RETIRO', label: 'RETIRO' },
    { value: 'SAN JAVIER', label: 'SAN JAVIER' },
    { value: 'VILLA ALEGRE', label: 'VILLA ALEGRE' },
    { value: 'YERBAS BUENAS', label: 'YERBAS BUENAS' },
    { value: 'SANTIAGO', label: 'SANTIAGO' },
    { value: 'CERRILLOS', label: 'CERRILLOS' },
    { value: 'CERRO NAVIA', label: 'CERRO NAVIA' },
    { value: 'CONCHALI', label: 'CONCHALI' },
    { value: 'EL BOSQUE', label: 'EL BOSQUE' },
    { value: 'ESTACION CENTRAL', label: 'ESTACION CENTRAL' },
    { value: 'HUECHURABA', label: 'HUECHURABA' },
    { value: 'INDEPENDENCIA', label: 'INDEPENDENCIA' },
    { value: 'LA CISTERNA', label: 'LA CISTERNA' },
    { value: 'LA FLORIDA', label: 'LA FLORIDA' },
    { value: 'LA GRANJA', label: 'LA GRANJA' },
    { value: 'LA PENTANA', label: 'LA PENTANA' },
    { value: 'LA REINA', label: 'LA REINA' },
    { value: 'LAS CONDES', label: 'LAS CONDES' },
    { value: 'LO BARNECHEA', label: 'LO BARNECHEA' },
    { value: 'LO ESPEJO', label: 'LO ESPEJO' },
    { value: 'LO PRADO', label: 'LO PRADO' },
    { value: 'MACUL', label: 'MACUL' },
    { value: 'MAIPU', label: 'MAIPU' },
    { value: 'PUENTE ALTO', label: 'PUENTE ALTO' },
    { value: 'PIRQUE', label: 'PIRQUE' },
    { value: 'SAN JOSE DE MAIPO', label: 'SAN JOSE DE MAIPO' },
    { value: 'COLINA', label: 'COLINA' },
    { value: 'LAMPA', label: 'LAMPA' },
    { value: 'TILTIL', label: 'TILTIL' },
    { value: 'SAN BERNARDO', label: 'SAN BERNARDO' },
    { value: 'BUIN', label: 'BUIN' },
    { value: 'CALERA DE TANGO', label: 'CALERA DE TANGO' },
    { value: 'PAINE', label: 'PAINE' },
    { value: 'MELIPILLA', label: 'MELIPILLA' },
    { value: 'ALHUE', label: 'ALHUE' },
    { value: 'CURACAVI', label: 'CURACAVI' },
    { value: 'MARIA PINTO', label: 'MARIA PINTO' },
    { value: 'SAN PEDRO', label: 'SAN PEDRO' },
    { value: 'TALAGANTE', label: 'TALAGANTE' },
    { value: 'EL MONTE', label: 'EL MONTE' },
    { value: 'ISLA DE MAIPO', label: 'ISLA DE MAIPO' },
    { value: 'PADRE HURTADO', label: 'PADRE HURTADO' },
    { value: 'PENAFLOR', label: 'PENAFLOR' },
    { value: 'IQUIQUE', label: 'IQUIQUE' },
    { value: 'ALTO HOSPICIO', label: 'ALTO HOSPICIO' },
    { value: 'POZO ALMONTE', label: 'POZO ALMONTE' },
    { value: 'CAMINA', label: 'CAMINA' },
    { value: 'COLCHANE', label: 'COLCHANE' },
    { value: 'HUARA', label: 'HUARA' },
    { value: 'PICA', label: 'PICA' },
    { value: 'VALPARAISO', label: 'VALPARAISO' },
    { value: 'CASABLANCA', label: 'CASABLANCA' },
    { value: 'CON CON', label: 'CON CON' },
    { value: 'ISLA JUAN FERNANDEZ', label: 'ISLA JUAN FERNANDEZ' },
    { value: 'PUCHUNCAVI', label: 'PUCHUNCAVI' },
    { value: 'QUINTERO', label: 'QUINTERO' },
    { value: 'VINA DEL MAR', label: 'VINA DEL MAR' },
    { value: 'ISLA DE PASCUA', label: 'ISLA DE PASCUA' },
    { value: 'LOS ANDES', label: 'LOS ANDES' },
    { value: 'CALLE LARGA', label: 'CALLE LARGA' },
    { value: 'RINCONADA', label: 'RINCONADA' },
    { value: 'SAN ESTEB', label: 'SAN ESTEB' }
];

export const cityCheckListChl = [
    { value: 'COIHAIQUE', label: 'COIHAIQUE' },
    { value: 'AISEN', label: 'AISEN' },
    { value: 'CAPITAN PRAT', label: 'CAPITAN PRAT' },
    { value: 'GENERAL CARRERA', label: 'GENERAL CARRERA' },
    { value: 'ANTOFGASA', label: 'ANTOFGASA' },
    { value: 'EL LOA', label: 'EL LOA' },
    { value: 'TOCOPILLA', label: 'TOCOPILLA' },
    { value: 'ARICA', label: 'ARICA' },
    { value: 'PARINACOTA', label: 'PARINACOTA' },
    { value: 'CAUTIN', label: 'CAUTIN' },
    { value: 'MALLECO', label: 'MALLECO' },
    { value: 'COPIAPO', label: 'COPIAPO' },
    { value: 'CHANARAL', label: 'CHANARAL' },
    { value: 'HUASCO', label: 'HUASCO' },
    { value: 'CONCEPCION', label: 'CONCEPCION' },
    { value: 'ARAUCO', label: 'ARAUCO' },
    { value: 'BIOBIO', label: 'BIOBIO' },
    { value: 'NUBLE', label: 'NUBLE' },
    { value: 'ELQUI', label: 'ELQUI' },
    { value: 'CHOAPA', label: 'CHOAPA' },
    { value: 'LIMARI', label: 'LIMARI' },
    { value: 'CACHAPOAL', label: 'CACHAPOAL' },
    { value: 'CARDENAL CARO', label: 'CARDENAL CARO' },
    { value: 'COLCHAGUA', label: 'COLCHAGUA' },
    { value: 'LLANQUIHUE', label: 'LLANQUIHUE' },
    { value: 'CHILOE', label: 'CHILOE' },
    { value: 'OSORNO', label: 'OSORNO' },
    { value: 'PALENA', label: 'PALENA' },
    { value: 'VALDIVIA', label: 'VALDIVIA' },
    { value: 'RANCO', label: 'RANCO' },
    { value: 'MAGALLANES', label: 'MAGALLANES' },
    { value: 'ANTARTICA CHILENA', label: 'ANTARTICA CHILENA' },
    { value: 'TIERRA DEL FUEGO', label: 'TIERRA DEL FUEGO' },
    { value: 'ULTIMA ESPERANZA', label: 'ULTIMA ESPERANZA' },
    { value: 'TALCA', label: 'TALCA' },
    { value: 'CAUQUENES', label: 'CAUQUENES' },
    { value: 'CURICO', label: 'CURICO' },
    { value: 'LINARES', label: 'LINARES' },
    { value: 'SANTIAGO', label: 'SANTIAGO' },
    { value: 'CORDILLERA', label: 'CORDILLERA' },
    { value: 'CHACABUCO', label: 'CHACABUCO' },
    { value: 'MAIPO', label: 'MAIPO' },
    { value: 'MELIPLLA', label: 'MELIPLLA' },
    { value: 'TALAGANTE', label: 'TALAGANTE' },
    { value: 'IQUIQUE', label: 'IQUIQUE' },
    { value: 'TAMARUGAL', label: 'TAMARUGAL' },
    { value: 'VALPARAISO', label: 'VALPARAISO' },
    { value: 'ISLA DE PASCUA', label: 'ISLA DE PASCUA' },
    { value: 'LOS ANDES', label: 'LOS ANDES' },
    { value: 'PETORCA', label: 'PETORCA' },
    { value: 'QUILLOTA', label: 'QUILLOTA' },
    { value: 'SAN ANTONIO', label: 'SAN ANTONIO' },
    { value: 'SAN FELIPE', label: 'SAN FELIPE' },
    { value: 'MARGA MARGA', label: 'MARGA MARGA' }
];

export const stateCheckListChl = [
    { value: 'AI', label: 'Aisén del General Carlos Ibañez del Campo' },
    { value: 'AN', label: 'Antofagasta' },
    { value: 'AP', label: 'Arica y Parinacota' },
    { value: 'AR', label: 'Araucanía' },
    { value: 'AT', label: 'Atacama' },
    { value: 'BI', label: 'Bío-Bío' },
    { value: 'CO', label: 'Coquimbo' },
    { value: 'LI', label: `Libertador General Bernardo O'Higgins` },
    { value: 'LL', label: 'Los Lagos' },
    { value: 'LR', label: 'Los Ríos' },
    { value: 'MA', label: 'Magallanes' },
    { value: 'ML', label: 'Maule' },
    { value: 'RM', label: 'Región Metropolitana de Santiago' },
    { value: 'TA', label: 'Tarapacá' },
    { value: 'VS', label: 'Valparaíso' }
];
